import React from 'react';
import { Image, Popover, Tooltip, theme } from 'antd';
import { PhotoTagPicker } from './PhotoTagPicker';
import { photoLabel, photoFullLabel } from '../models/photoTags';
import './photo-tags.css';

export function TaggedPhotoTile({ src, photo, parts, editable, disabled, onChange }) {
  const { token } = theme.useToken();
  const label = photo?.part_removed ? 'Choose part' : photoLabel(photo, parts);
  const strip = <button type="button" className="query-photo-tile-label" disabled={!editable}
    aria-label={`Shows: ${label}`} style={{ color: token.colorWhite,
      background: photo?.part_removed ? token.colorWarning : token.colorBgMask,
      cursor: editable ? 'pointer' : 'default' }}>
    <span>{label}</span>{editable && <span aria-hidden="true">▾</span>}
  </button>;
  return <div className="query-photo-tile" data-testid="tagged-photo-tile" style={{ borderColor: token.colorBorder }}>
    <Image alt="Query photo" src={src} width={72} height={72} preview={{ src }} />
    <Tooltip title={photoFullLabel(photo, parts)}>
      {editable ? <Popover trigger="click" placement="bottom" content={<PhotoTagPicker photo={photo} parts={parts} disabled={disabled} onChange={onChange} />}>{strip}</Popover> : strip}
    </Tooltip>
  </div>;
}
